<p-toast position="top-right"></p-toast>

<div class="root-body"
     data-testid="finance-dashboard"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic}">
    <div class="flex-row mb-3" style="margin-right: -30px;">

        <p-breadcrumb class="breadcrumb mr-5" [model]="breadcrumbs"></p-breadcrumb>
        <!--<div>
            <p-selectButton class="service-type-dashboard-top-item" (onChange)="getServiceTypeDashboardStats()" [options]="vehicleTypes" [(ngModel)]="selectedVehicleType" optionLabel="label" optionValue="value"></p-selectButton>
        </div>-->
        <div class="filler"></div>
        <div style="margin-right: 30px;">
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        (onSelect)="handleChangeDateRange()" [(ngModel)]="selectedDateRange" selectionMode="range" [readonlyInput]="true" [showIcon]="true"></p-calendar>
        </div>
    </div>

    <section class="dashboard-section-flex" style="width: 101.5%;">
        <div class="dashboard-col-md-6">
            <div class="service-type-dashboard-card" style="margin-right: 10px">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Total Revenue (php)</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-title">{{financeDashboard.TotalRevenue}}</div>
                <p-chart [type]="'line'"
                         [data]="totalRevenueChartData"
                         [options]="totalRevenueChartOptions"></p-chart>

            </div>
        </div>

        <div class="dashboard-col-md-6">
            <div class="service-type-dashboard-card" style="margin-right: 10px">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Total Profit (php)</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-title">{{financeDashboard.TotalProfit}}</div>
                <p-chart [type]="'line'"
                         [data]="totalProfitChartData"
                         [options]="totalProfitChartOptions"></p-chart>

            </div>
        </div>
    </section>

    <section class="dashboard-section-flex mt-4">
        <div class="dashboard-col-md-12">
            <div class="service-type-dashboard-card">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Month on Month Revenue (php)</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <div class="statistic-title">{{financeDashboard.TotalMonth}}</div>
                <p-chart type="bar"
                         [data]="totalMonthRevenueChartData"
                         [options]="totalMonthRevenueChartOptions"></p-chart>

            </div>
        </div>
    </section>

    <section class="dashboard-section-flex mt-4">
        <div class="dashboard-col-md-12" style="margin-bottom: 20px;">
            <div class="service-type-dashboard-card">
                <div class="service-type-dashboard-card__header">
                    <div class="service-type-dashboard-card-title">Avg</div>
                    <div class="service-type-dashboard-card-title-btn">Export Report</div>
                </div>
                <div style="height: 90px; border-top: 2px solid #cedae0;" class="flex flex-row">
                    <div class="perfomance-stats-item perfomance-stats-item-percent" style="border-right: 1px solid #cedae0">
                        <div class="statistic-title">{{financeDashboard.TotalAvgSpendUser}}</div>
                        <div class="statistic-description">AVG SPEND PER USER</div>
                    </div>

                    <div class="perfomance-stats-item perfomance-stats-item-percent">
                        <div class="statistic-title">{{financeDashboard.TotalAvgTransactionValue}}</div>
                        <div class="statistic-description">AVG TRANSACTION VALUE (ACTIVE PARTNERS)</div>
                    </div>
                </div>
                <div class="service-type-dashboard-card-title-separator"></div>
                <p-chart [type]="'bar'"
                         [data]="avgChartData"
                         [options]="avgChartOptions"
                         height="300"></p-chart>

            </div>
        </div>
    </section>

</div>
